// extracted by mini-css-extract-plugin
export default {"equipmentTable":"equipmentTable_equipmentTable__sKdmi"};